import {MoonIcon, SunIcon} from 'lucide-react';
import {useCallback, useState} from 'react';

import {Button} from '@/components/ui/button.js';
import type {Theme} from '@/lib/theme.js';
import {applyTheme, currentTheme} from '@/lib/theme.js';

/**
 * Switches between the light and dark themes.
 *
 * @returns The rendered toggle button.
 */
export function ThemeToggle(): React.JSX.Element {
  const [theme, setTheme] = useState<Theme>(() => currentTheme());

  const toggle = useCallback(() => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    setTheme(next);
  }, [theme]);

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
    >
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </Button>
  );
}
